export const RELOAD_CURRENT_TAB = 'app/UserPage/RELOAD_CURRENT_TAB';
export const RELOAD_ALL_TABS = 'app/UserPage/RELOAD_ALL_TABS';
